import React from "react";

export default function SectionHeading({ children, dark = false, id }) {
  return (
    <div className="flex items-center justify-center gap-4 sm:gap-6" id={id}>
      <span className="hidden sm:block h-px w-16 md:w-28 bg-gradient-to-r from-transparent to-gold/70" />
      <h2
        className={`text-center font-display font-medium tracking-wide text-3xl sm:text-4xl md:text-5xl ${
          dark ? "text-ivory" : "text-onyx"
        }`}
      >
        {children}
      </h2>
      <span className="hidden sm:block h-px w-16 md:w-28 bg-gradient-to-l from-transparent to-gold/70" />
    </div>
  );
}
